var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 44,
    viewBox: "0 0 49 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 30.8945C23.1581 30.8945 22.0332 32.0194 22.0332 33.3613C22.0332 34.7032 23.1581 35.8281 24.5 35.8281C25.7926 35.8281 26.9668 34.7033 26.9076 33.4205C26.9668 32.0095 25.8518 30.8945 24.5 30.8945Z",
    fill: "#39695B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.332 39.6377C48.8811 36.9637 48.891 33.7766 47.3517 31.1124L31.8998 4.35275C30.3704 1.65902 27.6076 0.0605469 24.5093 0.0605469C21.411 0.0605469 18.6482 1.66889 17.1188 4.34289L1.6471 31.1322C0.107828 33.8259 0.117695 37.0327 1.6767 39.7067C3.21598 42.3511 5.96891 43.9397 9.04746 43.9397H39.9119C43.0003 43.9397 45.773 42.3314 47.332 39.6377ZM43.9771 37.7037C43.1187 39.1838 41.5992 40.0619 39.902 40.0619H9.03759C7.36018 40.0619 5.85051 39.2035 5.0118 37.753C4.16322 36.2828 4.15336 34.5265 5.00193 33.0464L20.4736 6.26698C21.3123 4.79678 22.8121 3.92847 24.5093 3.92847C26.1966 3.92847 27.7062 4.80664 28.5449 6.27685L44.0067 33.0563C44.8356 34.4969 44.8257 36.2335 43.9771 37.7037Z",
    fill: "#39695B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8868 13.5794C22.7126 13.9149 21.9824 14.9805 21.9824 16.2731C22.0416 17.0526 22.091 17.842 22.1502 18.6215C22.3179 21.5915 22.4856 24.5023 22.6534 27.4723C22.7126 28.4788 23.4921 29.209 24.4985 29.209C25.505 29.209 26.2944 28.4295 26.3437 27.4131C26.3437 26.8014 26.3437 26.239 26.4029 25.6173C26.5114 23.713 26.6298 21.8086 26.7384 19.9042C26.7976 18.6709 26.9061 17.4375 26.9653 16.2041C26.9653 15.76 26.9061 15.3654 26.7384 14.9707C26.2352 13.8656 25.061 13.3031 23.8868 13.5794Z",
    fill: "#39695B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f842f48e05291445a3d5b2e3b5f2a191.svg";
export { ForwardRef as ReactComponent };